var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 9C1.16421 9 1.5 9.33579 1.5 9.75V15.375C1.5 15.9963 2.00368 16.5 2.625 16.5H15.375C15.9963 16.5 16.5 15.9963 16.5 15.375V9.75C16.5 9.33579 16.8358 9 17.25 9C17.6642 9 18 9.33579 18 9.75V15.375C18 16.8247 16.8247 18 15.375 18H2.625C1.17525 18 0 16.8247 0 15.375V9.75C0 9.33579 0.335786 9 0.75 9Z",
    fill: "#777777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9053 9.00648C13.1982 8.71359 13.1982 8.23872 12.9053 7.94582C12.6124 7.65293 12.1376 7.65293 11.8447 7.94582L9.96096 9.82953V0.954664C9.96096 0.427418 9.53354 2.30466e-08 9.00629 0C8.47905 -2.30467e-08 8.05163 0.427419 8.05163 0.954665L8.05163 9.84262L6.15483 7.94582C5.86194 7.65293 5.38707 7.65293 5.09417 7.94582C4.80128 8.23871 4.80128 8.71359 5.09417 9.00648L8.46942 12.3817C8.76231 12.6746 9.23719 12.6746 9.53008 12.3817L12.9053 9.00648Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadSmall);
export default __webpack_public_path__ + "static/media/Download_small.6343c34dbf7cbe6aa5748d59dc11ba43.svg";
export { ForwardRef as ReactComponent };